const fetchDetail_Url =
    window.location.hostname === "localhost"
        ? "https://shackbox-api.aleaspeaks.com/api/"
        : window.location.hostname === "shackbox.aleaspeaks.com"
            ? "https://shackbox-api.aleaspeaks.com/api/"
            : "https://api.shackbox.monetyz.com/api/"; 

export { fetchDetail_Url };
